// extracted by mini-css-extract-plugin
module.exports = {"back-arrow":"BackButton_back-arrow__nCfnE","clicked":"BackButton_clicked__MxZ0C"};